import DispatchTable from "./content/dispatch-table.jsx";
import LinkedTable from "./content/linked-table.jsx";
import Attachments from "./content/attachments.jsx";
import Chat from "./content/chat.jsx";
import Observations from "./content/observations.jsx";
import InitialInfo from "./content/initial-info.jsx";
import FactAddress from "./content/fact-address.jsx";
import ApplicationsDetails from "./content/applications-details.jsx";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";

const hasItems = (items) => Array.isArray(items) && items.length > 0;

export default function ReportContent({ id, data, printOptions }) {
    const attendance = data?.attendance ?? {};
    const attendanceData = attendance?.data ?? data?.data ?? {};

    const hasData = Object.keys(attendanceData).length > 0;
    const isAnonymous = Boolean(attendanceData?.attendance_anonymous);

    const sections = {
        linked: hasItems(attendance?.linked),
        dispatch: hasItems(attendance?.dispatch),
        attachment: hasItems(attendance?.attachment),
    }

    if (!hasData) {
        return  (
            <div id="dataNotFound" className="alert alert-info p-2 mt-5 h6 text-center">
                Nenhum registro encontrado.
            </div>
        )
    }

    return (
        <div className="space-y-4">
            <InitialInfo data={data} printOptions={printOptions} />

            <FactAddress title="ENDEREÇO DO FATO" data={data} printOptions={printOptions} />

            {!isAnonymous && (
                <ApplicationsDetails title="DADOS DO SOLICITANTE" data={data} printOptions={printOptions} />
            )}

            <Observations title="OBSERVAÇÕES" data={data} />

            {sections.linked && (
                <LinkedTable title="ATENDIMENTOS VINCULADOS" data={data} />
            )}

            {sections.dispatch && (
                <DispatchTable title="DESPACHOS" data={data} />
            )}

            {sections.attachment && (
                <Attachments title="ANEXOS" data={data} printOptions={printOptions} />
            )}

            {attendanceData?.attendance_end && id && (
               <Chat
                   title="HISTÓRICO DO CHAT"
                    id={id}
               />
            )}


        </div>
    )
}